import { render, staticRenderFns } from "./indentList.vue?vue&type=template&id=cbb9966a&scoped=true"
import script from "./indentList.vue?vue&type=script&lang=js"
export * from "./indentList.vue?vue&type=script&lang=js"
import style0 from "./indentList.vue?vue&type=style&index=0&id=cbb9966a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb9966a",
  null
  
)

export default component.exports